export default {
  MY_PERSONS ({ persons }) {
    return persons
  },
  PERSON ({ person }) {
    return person
  }
}
